import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  EditorialVision,
  PlanInstitutional,
  AntennaAndRadio,
  DigestSeo,
  ClosingPitch,
  AreYouReady,
} from './components';

const LandingMediaKitColegioAbogadosCaracas = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container>
        <EditorialVision />
      </Container>
      <Container>
        <PlanInstitutional />
      </Container>
      <Container>
        <AntennaAndRadio />
      </Container>
      <Container>
        <DigestSeo />
      </Container>
      <Container>
        <ClosingPitch />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitColegioAbogadosCaracas.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitColegioAbogadosCaracas;
